import { render } from "./App.vue?vue&type=template&id=dfa379c2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=dfa379c2&lang=scss"
script.render = render

export default script